<template>
  <div>
    <div v-if="!success" class="flex items-end mb-2">
      <sky-input v-model="email" small class="flex-1" label="Alerte retour de stock:" placeholder="Entrez votre e-mail.." />
      <sky-btn
        :loading="sending"
        :disabled="sending"
        class="bg-sky_blue text-white"
        small
        dark
        @click="send"
      >
        Envoyer
      </sky-btn>
    </div>
    <div v-else class="flex-1 bg-success text-white text-sm px-2 py-1 rounded">
      Alerte configurée avec succès!
    </div>
    <div v-if="error" class="flex-1 bg-red-500 text-white text-sm px-2 py-1 rounded">
      {{ error }}
    </div>
  </div>
</template>

<script>
import isEmail from 'is-email'

export default {
  props: {
    productId: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      email: null,
      sending: false,
      error: null,
      success: false
    }
  },
  methods: {
    async send () {
      this.sending = true
      this.error = null
      if (!isEmail(this.email)) {
        this.error = 'Vous devez entrer une adresse e-mail valide'
        this.sending = false
        return
      }

      try {
        await this.$api.post('/out-of-stock-email', {
          sku: this.productId,
          email: this.email
        })
        this.success = true
      } catch (error) {
        this.$gtmEvents.onRuntimeError(error, 'product/set-out-of-stock-email')
        this.error = 'L\'alerte n\'a pas pu être enregistrée. Vérifiez votre adresse e-mail.'
      }
      this.sending = false
    }
  }
}
</script>
